import { useCallback, useEffect, useState } from 'react'
import ContainerLayout from '../../../components/container-layout/ContainerLayout';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { useTranslation } from 'react-i18next';
import { Box, Button, Typography } from '@mui/material';
import { colors_button } from '../../../components/button/util.button';
import { ReactComponent as Iconadd } from "../../../assets/icons/add.svg";
import { ReactComponent as Iconbag } from "../../../assets/icons/bag.svg";
import { ReactComponent as Iconpassword } from "../../../assets/icons/password-check.svg";
import { ReactComponent as IconFolder } from "../../../assets/icons/folder-2.svg";
import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ModalCustom from '../../../components/modal/ModalCustom';
import InputTextField from '../../../components/input/inputTextField';
import { ButtonBack, ButtonPrimary } from '../../../components/button/ButtonCustoms';
import { degreeApi } from '../../../api/degree/degree.api';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useDispatch } from 'react-redux';
import StateComponents from '../../../components/state-component/StateComponents';
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import { facultyApi } from '../../../api/factulty/factulty.api';
import { PaymentChannelsApi } from '../../../api/payment-channels/payment-channels.api';
// import { TreeItem } from '@mui/x-tree-view/TreeItem/TreeItem';
function StyledTreeItem(props: any) {
  const { labelText, icon: IconComponent, ...other } = props;

  return (
    <TreeItem
      label={
        <Box sx={{ display: 'flex', alignItems: 'center', padding: '10px 0px' }}>
          {IconComponent && <IconComponent sx={{ mr: '5px' }} />}
          <Typography variant="body2">{labelText}</Typography>
        </Box>
      }
      {...other}
    />
  );
}
export default function LevelFacultyManagement() {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const [data, setData] = useState<any[]>([]);
  const [paymentChannelList, setPaymentChannelList] = useState<any[]>([]);

  const [form, setForm] = useState<any>();
  const [open, setOpen] = useState<boolean>(false)
  const [openFaculty, setOpenFaculty] = useState<boolean>(false)
  const [keyword, setKeyword] = useState<string>("");
  const [type, setType] = useState<string>("");

  const handleClose = () => {
    setOpen(false)
    setOpenFaculty(false)
    // setForm(null)
  }

  const handleGetData = useCallback(async () => {
    let query: any = {

    }
    if (keyword) query = { ...query, search: keyword }
    // if (startDate) query = { ...query, start_date: moment(startDate).format("YYYY-MM-DD") }
    // if (endDate) query = { ...query, end_date: moment(endDate).format("YYYY-MM-DD") }
    dispatch(setLoading());
    await degreeApi.tree(query).then((res) => {
      if (res.status < 300) {
        setData(res.data?.data || []);
      }
    }).catch((err) => {
      console.log(err)
    }).finally(() => {
      dispatch(unsetLoading());
    })
  }, [keyword])
  useEffect(() => {
    handleGetData()
  }, [handleGetData])

  const handleSubmit = async () => {
    const body = {
      ...form,
    }
    if (form?.id_degree) {
      dispatch(setLoading());
      await degreeApi.patchDegree(Number(form?.id_degree), body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("LEVEL_FACULTY_EDIT_LEVEL"), t("LEVEL_FACULTY_EDIT_LEVEL_COMPLETED"));
            handleClose()
            handleGetData()
            // navigate(routeName.admission.ManagePayment)
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("LEVEL_FACULTY_EDIT_LEVEL"), t("LEVEL_FACULTY_EDIT_LEVEL_FAILED"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    } else {
      dispatch(setLoading());
      await degreeApi.postDegree(body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("LEVEL_FACULTY_ADD_LEVEL"), t("LEVEL_FACULTY_ADD_LEVEL_COMPLETED"));
            handleClose()
            handleGetData()
            // navigate(routeName.admission.ManagePayment)
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("LEVEL_FACULTY_ADD_LEVEL"), t("LEVEL_FACULTY_ADD_LEVEL_FAILED"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }

  }
  const handleSubmitfaculty = async () => {
    const body = {
      ...form,
      id_degree_ref: form?.id_degree
    }
    if (form?.id_faculty) {
      dispatch(setLoading());
      await facultyApi.patchFaculty(Number(form?.id_faculty), body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("LEVEL_FACULTY_EDIT_COURSE"), t("LEVEL_FACULTY_EDIT_COURSE_COMPLETED"));
            handleClose()
            handleGetData()
            // navigate(routeName.admission.ManagePayment)
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("LEVEL_FACULTY_EDIT_COURSE"), t("LEVEL_FACULTY_EDIT_COURSE_FAILED"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    } else {
      dispatch(setLoading());
      await facultyApi.postFaculty(body)
        .then((res) => {
          if (res.status < 300) {
            alertSuccess(t("LEVEL_FACULTY_ADD_COURSE"), t("LEVEL_FACULTY_ADD_COURSE_COMPLETED"));
            handleClose()
            handleGetData()
            // navigate(routeName.admission.ManagePayment)
          }
        })
        .catch((err) => {
          console.log(err);
          alertError(t("LEVEL_FACULTY_ADD_COURSE"), t("LEVEL_FACULTY_ADD_COURSE_FAILED"));
        })
        .finally(() => {
          dispatch(unsetLoading());
        });
    }


  }

  const getPaymentChannelList = async () => {
    let query: any = {
      page: 1,
      limit: 1000
    }
    await PaymentChannelsApi.getPaymentChannelList(query).then((res) => {
      if (res.status < 300) {
        setPaymentChannelList(res.data?.data?.items || []);
      }
    }).catch((err) => {
      console.log(err)
    })
  }
  useEffect(() => {
    getPaymentChannelList()
  }, [])

  const handleDeleteDegree = (id: number) => {
    alertActive(t("LEVEL_FACULTY_DELETE_DATA"), t("LEVEL_FACULTY_CONFIRM_DELETE"), undefined, undefined, async () => {
      dispatch(setLoading());
      await degreeApi.deleteDegree(id).then((res) => {
        if (res.status < 300) {
          alertSuccess(t("LEVEL_FACULTY_DELETE_DATA"), t("LEVEL_FACULTY_DELETE_COMPLETED"))
          handleGetData();
        }
      }).catch((err) => {
        console.log(err)
        alertError(t("LEVEL_FACULTY_DELETE_DATA"), t("LEVEL_FACULTY_DELETE_FAILED"))
      }).finally(() => {
        dispatch(unsetLoading());
      })
    })
  }
  const handleDeleteFaculty = (id: number) => {
    alertActive(t("LEVEL_FACULTY_DELETE_DATA"), t("LEVEL_FACULTY_CONFIRM_DELETE"), undefined, undefined, async () => {
      dispatch(setLoading());
      await facultyApi.deleteFaculty(id).then((res) => {
        if (res.status < 300) {
          alertSuccess(t("LEVEL_FACULTY_DELETE_DATA"), t("LEVEL_FACULTY_DELETE_COMPLETED"))
          handleGetData();
        }
      }).catch((err) => {
        console.log(err)
        alertError(t("LEVEL_FACULTY_DELETE_DATA"), t("LEVEL_FACULTY_DELETE_FAILED"))
      }).finally(() => {
        dispatch(unsetLoading());
      })
    })
  }
  return (
    <div>
      <ContainerLayout
        title={t("LEVEL_FACULTY_MANAGE")}
        hidden_sub_title
        navigateContent={
          // <NavigateListCustom
          //   navigateData={[
          //     {
          //       key: "1",
          //       name: t("ระบบ Edpex"),
          //       disabled_match: true,
          //       pathName: routeName.cms.edpexResultDisplay,
          //     },
          //     {
          //       key: "2",
          //       name: t("เกณฑ์คะแนน Edpex"),
          //       pathName: routeName.cms.edpexCriteria,
          //     },
          //   ]}
          // />
          <></>
        }
        content={
          <>
            <div className="w-full grid grid-cols-12 gap-4">
              {/* Left Panel - Standard Points */}
              <div className="col-span-12 border-2 rounded-lg border-gray-300 relative h-[580px]">
                <div className="p-4">
                  <Typography variant="h5">{t('LEVEL_FACULTY_INFO')}</Typography>
                  <div className="p-4 h-[390px] overflow-auto">
                    {/* <TreeViewComponent treeData={standardPoints} /> */}
                    <TreeView
                      aria-label="file system navigator"
                      defaultCollapseIcon={<ExpandMoreIcon />}
                      defaultExpandIcon={<ChevronRightIcon />}
                    >
                     
                      {data?.map((item: any, index: number) => {
                        return (
                          <StyledTreeItem nodeId={index + 'degree'} labelText={i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name} icon={IconFolder} onClick={(e: any) => {
                            // e.stopPropagation();
                            if (form?.id_degree === item?.id_degree) {
                              setForm({
                                name: '',
                                name_eng: ''
                              })
                              setType('degree')
                            } else {
                              setForm({
                                ...item,
                                name: item?.degree_name,
                                name_eng: item?.degree_name_eng
                              })
                              setType('degree')
                            }

                          }}>
                            {item?.faculty?.map((x: any, i: number) => {
                              return (
                                <StyledTreeItem nodeId={i + 'faculty' + x?.id_degree} labelText={i18n.language === "en" ? (x?.faculty_name_eng || x?.faculty_name) : x?.faculty_name} icon={IconFolder} onClick={(e: any) => {
                                  // e.stopPropagation();
                                  setForm({
                                    ...x,
                                    name: x?.faculty_name,
                                    name_eng: x?.faculty_name_eng
                                  })
                                  setType('faculty')

                                }} />
                              )
                            })}
                          </StyledTreeItem>
                        )
                      })}

                    </TreeView>
                  </div>
                </div>

                <div className="flex flex-col md:flex-row justify-center gap-4 mt-[40px] bg-[#DDE1EB] p-[46px] absolute bottom-0 left-0 right-0">
                  <Button
                    sx={{
                      background: colors_button.success,
                      ":hover": {
                        background: colors_button.success,
                      },
                      color: "#fff",
                      borderRadius: "6px",
                      padding: "6px 12px",
                    }}
                    onClick={() => {
                      if (form?.id_degree) {
                        setOpenFaculty(true)
                        setForm({
                          name: '',
                          name_eng: '',
                          id_degree: form?.id_degree,
                          id_payment_channels_register: '',
                          id_payment_channels_term: ''
                        })
                      }
                      else {
                        setOpen(true);
                        setForm({
                          name: '',
                          name_eng: '',
                        })
                      }


                    }}
                  >
                    <Iconadd className="me-1" />
                    {t("LEVEL_FACULTY_ADD")}
                  </Button>

                  <Button
                    sx={{
                      background: colors_button.primary,
                      ":hover": {
                        background: colors_button.primary,
                      },
                      color: "#fff",
                      borderRadius: "6px",
                      padding: "6px 12px",
                      whiteSpace: "nowrap",
                    }}
                    onClick={() => {
                      if (type === 'faculty') {
                        setOpenFaculty(true)

                      } else {
                        setOpen(true);

                      }
                    }}
                  >
                    <Iconpassword className="me-1" />
                    {t("LEVEL_FACULTY_EDIT")}
                  </Button>
                  <Button
                    sx={{
                      background: colors_button.red,
                      ":hover": {
                        background: colors_button.red,
                      },
                      color: "#fff",
                      borderRadius: "6px",
                      padding: "6px 12px",
                    }}
                    onClick={() => {
                      // handleDeleteStandardPoint();
                      if (type === 'faculty') {
                        handleDeleteFaculty(form?.id_faculty)

                      } else {
                        handleDeleteDegree(form?.id_degree)

                      }
                    }}
                  >
                    <Iconbag className="me-1" />
                    {t("ลบ")}
                  </Button>
                  {/* </>
                  )} */}
                </div>
              </div>

            </div>

            <ModalCustom
              title={
               t('LEVEL_FACULTY_MANAGE')
                // isEditableStandardPoint
                //   ? t("แก้ไขเกณฑ์คะแนน Edpex")
                //   : t("เพิ่มเกณฑ์คะแนน Edpex")
              }
              subTitle={t("")}
              open={open}
              component={
                <div className="flex flex-col gap-4">

                  <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[

                      {
                        seq: 1,
                        type: "SELECT",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          labelId: "ss",
                          heading: t("LEVEL_FACULTY_UNDER_LEVEL"),
                          onChange: (e) => {
                            // handleChange('form_type', index, e.target.value);
                          },
                          options: data?.map((item: any) => {
                            return {
                              label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                              value: item?.id_degree,
                            }
                          }),
                          selectId: "",
                          value: '',
                          disabled: true
                        }
                      },
                      {
                        seq: 2,
                        type: "TEXT_FIELD",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          heading: t("LEVEL_FACULTY_NAME_TH"),
                          onChange: (e) => { setForm({ ...form, name: e.target.value }) },
                          value: form?.name || ''
                        },
                      },
                      {
                        seq: 3,
                        type: "TEXT_FIELD",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          heading: t("LEVEL_FACULTY_NAME_EN"),
                          onChange: (e) => { setForm({ ...form, name_eng: e.target.value }) },
                          value: form?.name_eng || ''
                        },
                      },

                      {
                        seq: 4,
                        type: "SELECT",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          labelId: "ss",
                          heading: t("LEVEL_FACULTY_PAYMENT_METHOD"),
                          onChange: (e) => {
                            // handleChange('form_type', index, e.target.value);
                            // setForm({ ...form, id_payment_channels_register: e.target.value })
                          },
                          options: paymentChannelList?.filter((x) => x?.register_fees === 1)?.map((item) => {
                            return {
                              label: item?.payment_channels_name,
                              value: item?.id_payment_channels,
                            }
                          }),
                          selectId: "",
                          value: '',
                          disabled: true
                        }
                      },
                      {
                        seq: 5,
                        type: "SELECT",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          labelId: "ss",
                          heading: t("LEVEL_FACULTY_TUITION_PAYMENT_METHOD"),
                          onChange: (e) => {
                            // handleChange('form_type', index, e.target.value);
                            // setForm({ ...form, id_payment_channels_term: e.target.value })
                          },
                          options: paymentChannelList?.filter((x) => x?.term_fees === 1)?.map((item) => {
                            return {
                              label: item?.payment_channels_name,
                              value: item?.id_payment_channels,
                            }
                          }),
                          selectId: "",
                          value: '',
                          disabled: true
                        }
                      },
                    ]} />
                  <div className="flex justify-center gap-4">
                    <ButtonBack
                      onClick={() => {
                        handleClose();
                      }}
                      buttonName={t("LEVEL_FACULTY_CANCEL")}
                    />
                    <ButtonPrimary
                      onClick={() => handleSubmit()}
                      mode="add"
                      buttonName={t("LEVEL_FACULTY_CONFIRM")}
                    />
                    {/* {!isEditableStandardPoint ? (
                      <ButtonPrimary
                        onClick={() => handleCreateStandardPoint()}
                        mode="add"
                        buttonName={t("ยืนยัน")}
                      />
                    ) : (
                      <ButtonPrimary
                        onClick={() => setIsEditableStandardPoint(false)}
                        buttonName={t("แก้ไข")}
                      />
                    )} */}
                  </div>
                </div>
              }
            />
            <ModalCustom
              title={
                t('LEVEL_FACULTY_MANAGE')
                // isEditableStandardPoint
                //   ? t("แก้ไขเกณฑ์คะแนน Edpex")
                //   : t("เพิ่มเกณฑ์คะแนน Edpex")
              }
              subTitle={t("")}
              open={openFaculty}
              component={
                <div className="flex flex-col gap-4">

                  <StateComponents
                    otherProps={{ spacing: 2 }}
                    typeProps={[

                      {
                        seq: 1,
                        type: "SELECT",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          labelId: "ss",
                          heading: t("LEVEL_FACULTY_UNDER_LEVEL"),
                          onChange: (e) => {
                            // handleChange('form_type', index, e.target.value);
                          },
                          options: data?.map((item: any) => {
                            return {
                              label: i18n.language === "en" ? (item?.degree_name_eng || item?.degree_name) : item?.degree_name,
                              value: item?.id_degree,
                            }
                          }),
                          selectId: "",
                          value: form?.id_degree || '',
                          disabled: true
                        }
                      },

                      {
                        seq: 2,
                        type: "TEXT_FIELD",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          heading: t("LEVEL_FACULTY_NAME_TH"),
                          onChange: (e) => { setForm({ ...form, name: e.target.value }) },
                          value: form?.name || ''
                        },
                      },
                      {
                        seq: 3,
                        type: "TEXT_FIELD",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          heading: t("LEVEL_FACULTY_NAME_EN"),
                          onChange: (e) => { setForm({ ...form, name_eng: e.target.value }) },
                          value: form?.name_eng || ''
                        },
                      },
                      {
                        seq: 4,
                        type: "SELECT",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          labelId: "ss",
                          heading: t("LEVEL_FACULTY_PAYMENT_METHOD"),
                          onChange: (e) => {
                            // handleChange('form_type', index, e.target.value);
                            setForm({ ...form, id_payment_channels_register: e.target.value })
                          },
                          options: paymentChannelList?.filter((x) => x?.register_fees === 1)?.map((item) => {
                            return {
                              label: item?.payment_channels_name,
                              value: item?.id_payment_channels,
                            }
                          }),
                          selectId: "",
                          value: form?.id_payment_channels_register || '',
                        }
                      },
                      {
                        seq: 5,
                        type: "SELECT",
                        gridProps: {
                          xs: 12,
                        },
                        fieldProps: {
                          labelId: "ss",
                          heading: t("LEVEL_FACULTY_TUITION_PAYMENT_METHOD"),
                          onChange: (e) => {
                            // handleChange('form_type', index, e.target.value);
                            setForm({ ...form, id_payment_channels_term: e.target.value })
                          },
                          options: paymentChannelList?.filter((x) => x?.term_fees === 1)?.map((item) => {
                            return {
                              label: item?.payment_channels_name,
                              value: item?.id_payment_channels,
                            }
                          }),
                          selectId: "",
                          value: form?.id_payment_channels_term || '',
                        }
                      },
                    ]} />
                  <div className="flex justify-center gap-4">
                    <ButtonBack
                      onClick={() => {
                        handleClose();
                      }}
                      buttonName={t("LEVEL_FACULTY_CANCEL")}
                    />
                    <ButtonPrimary
                      onClick={() => handleSubmitfaculty()}
                      mode="add"
                      buttonName={t("LEVEL_FACULTY_CONFIRM")}
                    />
                    {/* {!isEditableStandardPoint ? (
                      <ButtonPrimary
                        onClick={() => handleCreateStandardPoint()}
                        mode="add"
                        buttonName={t("ยืนยัน")}
                      />
                    ) : (
                      <ButtonPrimary
                        onClick={() => setIsEditableStandardPoint(false)}
                        buttonName={t("แก้ไข")}
                      />
                    )} */}
                  </div>
                </div>
              }
            />


          </>
        }
      />
    </div>
  )
}
